import {createContext, useEffect, useState} from "react";
import {UsuarioInfor} from "@models/UsuarioInfor";
import {Logar} from "@services/AuthService";
import useStorage from "@hooks/useStore";
import {ServiceBase} from "@services/ServiceBase";
import {Snackbar, SnackbarOrigin} from "@material-ui/core";
import MuiAlert, {Color} from "@material-ui/lab/Alert";
import {AlertTitle} from '@material-ui/lab';



import axios from "axios";

interface AuthContextProps {
    token?: string;

    usuario?: UsuarioInfor;

    logar(usuario: string, senha: string): Promise<any>;

    deslogar(): void;

    showAlert(tipo: Color, mensagem: string, titulo);

    tema: {
        temaEscuro: boolean;
        setTemaEscuro(ETemaEscuro: boolean);
    };
}

export interface AlertState extends SnackbarOrigin {
    open: boolean;
    type: Color;
    message: string;
    title: string;

}

export const AuthContext = createContext<AuthContextProps>({} as any);

export const AuthProvider = ({children}) => {
    const [token, setToken] = useStorage<string>(`token`);
    const [usuario, setUsuario] = useStorage<UsuarioInfor>(`usuario`);


    const [temaEscuro, setTemaEscuro] = useStorage<boolean>("tema");





    useEffect(() => {

        ServiceBase.instance.defaults.headers.common["Authorization"] = "bearer " + token;

        ServiceBase.instance.defaults.headers["Authorization"] = "bearer " + token;
        if (!token) return;


    }, [token])


    useEffect(() => {

        ServiceBase.instance.interceptors.response.use(response => {
            return response;
        }, async error => {
            if (error.response?.status === 401) {
                if (!usuario) return;
                let user = await logar(usuario.login, usuario.senha);
                if (!user) {
                    showAlert("error", `Usuário INFORCFC ${usuario.nome} desconectado`, "Autenticação")
                }

                let {instance} = ServiceBase
                instance.defaults.headers.common["Authorization"] = "bearer " + user;

                error.response.config.headers["Authorization"] = "bearer " + user;
                return axios.request(error.response.config);

            }
            return error;
        });
    }, [])

    async function logar(login: string, senha: string) {


        try {
            let result = await Logar(login, senha);
            if (!result) {
                showAlert("error", "Usuário não encontrado!", 'Autenticação');
                return false
            }


            let {token: newToken, usuario} = result;

            setUsuario(usuario);
            setToken(newToken);
            return newToken;

        } catch (error) {
            console.error(error);
            return false;
        }

    }


    function deslogar() {
        setToken(null);
        setUsuario(null);
    }

    function showAlert(tipo: Color, mensagem: string, titulo = "") {
        setAlert({

            open: true,
            horizontal: "right",
            vertical: "top",
            type: tipo,
            message: mensagem,
            title: titulo
        })
    }

    const [alert, setAlert] = useState<AlertState>({
        open: false,
        horizontal: "right",
        vertical: "top",
        type: "success",
        message: "Olá! ",
        title: ""
    });
    const {vertical, horizontal, open, type, message, title} = alert;

    return (
        <AuthContext.Provider
            value={{
                token: token,
                usuario: usuario,
                deslogar,
                logar,
                showAlert,

                tema: {
                    temaEscuro,
                    setTemaEscuro
                }
            }}
        >

            {children}
            <Snackbar
                anchorOrigin={{vertical, horizontal}}
                open={open}
                onClose={() => setAlert({...alert, open: false})}
                message="I love snacks"
                key={vertical + horizontal}
                autoHideDuration={4000}
            >
                <MuiAlert elevation={6} variant="filled" severity={type}>
                    {title && <AlertTitle>{title}</AlertTitle>
                    }
                    {message}
                </MuiAlert>
            </Snackbar>
        </AuthContext.Provider>
    );
};
